export enum UserRoles {
  ADMIN = "admin",
  CR_API = "cr_api",
  ADMINWITHREADACCESS = "adminwithreadaccess",
  MEDIAREQUEST = "mediarequest",
  SUPERADMIN = "superadmin",
  OPS = "ops",
  REQUESTOR = "requestor",
  GLOBALADMIN = "globaladmin",
  LEGACY_GMSC = "legacygmsc"
}

export const PERMITTED_ROLES = {
  STATUS: ["admin", "superadmin", "adminwithreadaccess", "globaladmin"],
  RAW_USER_ROLES: ["AdminWithReadAccess", "Ops", "Requestor", "SuperAdmin", "Admin", "MediaRequest", "GlobalAdmin"],
  DEFAULT_SOURCE_ROLES: ["admin", "superadmin", "adminwithreadaccess", "globaladmin", "ops", "requestor"],
  MODAL_SOURCE_LOCATION_ROLES: ["admin", "superadmin", "globaladmin", "ops", "adminwithreadaccess"],
}
